import {MembersTexts} from '../../../../../commons/enums'
import {isSite} from '../../../../../commons/selectors/environment'
import {getUserText} from '../../selectors/component'
import {getNoUpcomingEventsUrl} from '../../selectors/navigation'
import {MemberPageContext} from '../../types/state'
import {connect} from '../connect'
import {NoEventsRuntimeProps} from './interfaces'
import {NoEvents as Presentation} from './no-events'

const mapRuntime = ({
  state,
  actions: {seeOtherEvents, navigateToNoUpcomingEventsUrl},
}: MemberPageContext): NoEventsRuntimeProps => ({
  navigate: !isSite(state) ? navigateToNoUpcomingEventsUrl : null,
  url: isSite(state) ? getNoUpcomingEventsUrl(state) : null,
  cta: getUserText(state, MembersTexts.noUpcomingEventsLink),
  seeOtherEvents,
})

export const NoEvents = connect<{}, NoEventsRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
